var _rect, _mask, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarginBottomicon = function SvgMarginBottomicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 4,
    y: 4,
    stroke: "currentColor",
    strokeWidth: 1.6,
    rx: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "margin-bottom_icon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1.6,
    y: 14.4,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1.6,
    y: 14.4,
    stroke: "currentColor",
    strokeWidth: 1.6,
    mask: "url(#margin-bottom_icon_svg__a)",
    rx: 0.5
  })));
};
export default SvgMarginBottomicon;